import {gql} from '@apollo/client';

export const GET_SORTER_PLAN_DETAIL = gql`
    query GetSorterPlanDetail($id: Long!) {
        getSorterPlanDetail(id: $id) {
            id
            sorterId
            sorterName
            sorterType
            warehouseId
            isSortingHub
            sorterPlanName
            status
            version
            isDropBag
            isSpecified
            printCount
            ppmodBagContainerId
            disabledChuteConfig
            fallbackChuteConfig
            chuteConfigs {
                id
                chuteCode
                leadChuteId
                matchesChuteIds
                chuteType
                exceptionCodes
                carrierCode
                sortingCode
                businessType
                printType
                ttBizType
                preSortingCode
                lastMileSortingCode
                isUse
            }
        }
    }
`;

export interface ChuteConfig {
    id?: number;
    chuteCode?: string | null;
    leadChuteId?: number | null;
    matchesChuteIds?: string | null;
    chuteType: number | null;
    exceptionCodes: string[] | null;
    carrierCode?: number | null;
    sortingCode?: string | null;
    businessType?: number | null;
    printType?: number | null;
    ttBizType?: string | null;
    preSortingCode?: string | null;
    lastMileSortingCode?: string | null;
    isUse?: boolean;
}

export interface SorterPlanDetail {
    id: number;
    sorterId?: number;
    sorterName?: string;
    sorterType?: number;
    warehouseId?: number;
    /** 作业仓是否分拣仓 */
    isSortingHub?: boolean;
    sorterPlanName?: string;
    status: number;
    version: number;
    isDropBag: boolean;
    isSpecified: boolean;
    printCount: number;
    /** PPMode 容器类型（bag_container.id），null-未配置 */
    ppmodBagContainerId?: number | null;
    disabledChuteConfig?: string;
    /** 兜底格口号（来自分拣机配置）；为空表示该设备无兜底格口 */
    fallbackChuteConfig?: string | null;
    chuteConfigs?: ChuteConfig[];
}

